import HelpTooltip from '@/app/common/components/HelpTooltip';
import type { ChangeEvent } from 'react';
import { Alert, Col, Form, Row, Tab } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';

interface IncludeExcludeValues {
  include_urls_is_enable: boolean;
  include_urls_value: string[];
  exclude_urls_is_enable: boolean;
  exclude_urls_value: string[];
}

type SetFieldValue = (
  field: string,
  value: unknown,
  shouldValidate?: boolean
) => Promise<unknown>;

interface IncludeExcludeProps {
  values: IncludeExcludeValues;
  setFieldValue: SetFieldValue;
}

const IncludeExclude = ({
  values,
  setFieldValue
}: IncludeExcludeProps) => {
  const includeEnabled = values.include_urls_is_enable === true;
  const excludeEnabled = values.exclude_urls_is_enable === true;

  const patternValue = (patterns: string[]): string => patterns.join('\n');

  const updatePatterns = (field: string, value: string) => {
    void setFieldValue(
      field,
      value
        .split('\n')
        .map(pattern => pattern.trim())
        .filter(Boolean)
    );
  };

  const handleEnabledChange = (
    enabledField: string,
    valueField: string,
    enabled: boolean
  ) => {
    void setFieldValue(enabledField, enabled);
    if (!enabled) {
      void setFieldValue(valueField, []);
    }
  };

  // تنظیمات شامل و استثناء خزش
  return (
    <Tab.Pane className="my-3" eventKey="crawlerIncludeExclude">
      <div dir="rtl" className="text-start">
        <Alert variant="info" className="fs--1 mb-3">
          این فیلترها فقط روی نشانی‌های داخل محدودهٔ دامنه اعمال می‌شوند.
          در صورت تعارض، استثنا بر شامل اولویت دارد؛ هر الگو را در یک سطر وارد
          کنید.
        </Alert>
        <Row className="g-3">
          <Col xs={12}>
            <div className="crawl-settings-box border rounded-2 p-3 h-100">
              <div className="d-flex align-items-center justify-content-between gap-3 mb-2">
                <Form.Label htmlFor="include_urls_is_enable" className="mb-0">
                  <span className="d-inline-flex align-items-center">
                    فعال‌سازی نشانی‌های شامل
                    <HelpTooltip
                      html={
                        crawlTooltip.crawlSettings
                          .crawlerIncludeExcludeTooltips.include
                      }
                    />
                  </span>
                </Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <span className="fs--1 text-700">
                    {includeEnabled ? 'بله' : 'خیر'}
                  </span>
                  <Form.Check
                    type="switch"
                    id="include_urls_is_enable"
                    name="include_urls_is_enable"
                    checked={includeEnabled}
                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                      handleEnabledChange(
                        'include_urls_is_enable',
                        'include_urls_value',
                        event.target.checked
                      )
                    }
                    aria-label="فعال‌سازی نشانی‌های شامل"
                  />
                </div>
              </div>
              <Form.Label htmlFor="include_urls_value" className="mb-1">
                الگوهای شامل (هر الگو در یک سطر)
              </Form.Label>
              <Form.Control
                as="textarea"
                id="include_urls_value"
                rows={3}
                name="include_urls_value"
                disabled={!includeEnabled}
                placeholder={'مثلاً:\n*blog*\n*product*'}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                  updatePatterns('include_urls_value', event.target.value)
                }
                value={patternValue(values.include_urls_value)}
              />
            </div>
          </Col>
          <Col xs={12}>
            <div className="crawl-settings-box border rounded-2 p-3 h-100">
              <div className="d-flex align-items-center justify-content-between gap-3 mb-2">
                <Form.Label htmlFor="exclude_urls_is_enable" className="mb-0">
                  <span className="d-inline-flex align-items-center">
                    فعال‌سازی نشانی‌های استثنا
                    <HelpTooltip
                      html={
                        crawlTooltip.crawlSettings
                          .crawlerIncludeExcludeTooltips.exclude
                      }
                    />
                  </span>
                </Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <span className="fs--1 text-700">
                    {excludeEnabled ? 'بله' : 'خیر'}
                  </span>
                  <Form.Check
                    type="switch"
                    id="exclude_urls_is_enable"
                    name="exclude_urls_is_enable"
                    checked={excludeEnabled}
                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                      handleEnabledChange(
                        'exclude_urls_is_enable',
                        'exclude_urls_value',
                        event.target.checked
                      )
                    }
                    aria-label="فعال‌سازی نشانی‌های استثنا"
                  />
                </div>
              </div>
              <Form.Label htmlFor="exclude_urls_value" className="mb-1">
                الگوهای استثنا (هر الگو در یک سطر)
              </Form.Label>
              <Form.Control
                as="textarea"
                id="exclude_urls_value"
                rows={3}
                name="exclude_urls_value"
                disabled={!excludeEnabled}
                placeholder={'مثلاً:\n*/admin/*\n*/login/*'}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                  updatePatterns('exclude_urls_value', event.target.value)
                }
                value={patternValue(values.exclude_urls_value)}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Tab.Pane>
  );
};

export default IncludeExclude;
